module.exports = __webpack_public_path__ + "c80ed0f282df9831372d37298ddb51e1.png";